import { render, staticRenderFns } from "./TheSnapshotCreateFolder.vue?vue&type=template&id=71d807c1&"
import script from "./TheSnapshotCreateFolder.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotCreateFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports